import { render, staticRenderFns } from "./balances.vue?vue&type=template&id=7fc511e1&scoped=true"
import script from "./balances.vue?vue&type=script&lang=js"
export * from "./balances.vue?vue&type=script&lang=js"
import style0 from "./balances.vue?vue&type=style&index=0&id=7fc511e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc511e1",
  null
  
)

export default component.exports